"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rate = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importStar(require("react"));
var controlled_1 = require("../form/controlled");
var icon_1 = require("../icon");
var util_1 = require("../util");
var inject_value_1 = require("../_util/inject-value");
var key_map_1 = require("../_util/key-map");
var defaultCharacter = function (size) { return [
    react_1.default.createElement(icon_1.Icon, { type: "star", className: size === "l" ? "size-l" : "" }),
    react_1.default.createElement(icon_1.Icon, { type: "star-warning", className: size === "l" ? "size-l" : "" }),
]; };
var primaryCharacter = function (size) { return [
    react_1.default.createElement(icon_1.Icon, { type: "star", className: size === "l" ? "size-l" : "" }),
    react_1.default.createElement(icon_1.Icon, { type: "star-primary", className: size === "l" ? "size-l" : "" }),
]; };
exports.Rate = react_1.default.forwardRef(function Rate(props, ref) {
    var classPrefix = util_1.useConfig().classPrefix;
    var _a = controlled_1.useDefaultValue(props, 0), value = _a.value, onChange = _a.onChange, _b = _a.count, count = _b === void 0 ? 5 : _b, _c = _a.allowClear, allowClear = _c === void 0 ? true : _c, allowHalf = _a.allowHalf, readonly = _a.readonly, theme = _a.theme, size = _a.size, _d = _a.character, character = _d === void 0 ? theme === "primary"
        ? primaryCharacter(size)
        : defaultCharacter(size) : _d, className = _a.className, restProps = tslib_1.__rest(_a, ["value", "onChange", "count", "allowClear", "allowHalf", "readonly", "theme", "size", "character", "className"]);
    // 内部
    var innerValue = Math.round(value * 2);
    var _e = tslib_1.__read(react_1.useState(-1), 2), hoverValue = _e[0], setHoverValue = _e[1];
    var current = hoverValue >= 0 ? hoverValue : innerValue;
    function handleClick(event, value) {
        if (readonly) {
            return;
        }
        setHoverValue(value);
        if (allowClear && innerValue === value) {
            onChange(0, { event: event });
            setHoverValue(-1);
            return;
        }
        onChange(Number((value / 2).toFixed(1)), {
            event: event,
        });
    }
    function handleMouseEnter(value) {
        if (readonly) {
            return;
        }
        setHoverValue(value);
    }
    function handleMouseLeave() {
        setHoverValue(-1);
    }
    function handleKeyDown(event) {
        if (readonly) {
            return;
        }
        switch (event.key) {
            case key_map_1.KeyMap.Left:
                setHoverValue(-1);
                if (innerValue >= 1) {
                    onChange(Number(((innerValue - (allowHalf ? 1 : 2)) / 2).toFixed(1)), { event: event });
                }
                break;
            case key_map_1.KeyMap.Right:
                setHoverValue(-1);
                if (innerValue < count * 2) {
                    onChange(Number(((innerValue + (allowHalf ? 1 : 2)) / 2).toFixed(1)), { event: event });
                }
                break;
            case key_map_1.KeyMap.Backspace:
                setHoverValue(-1);
                onChange(0, { event: event });
                break;
        }
    }
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-rate", className) }, restProps, { tabIndex: 0, role: "radiogroup", onMouseLeave: util_1.callBoth(restProps.onMouseLeave, handleMouseLeave), onKeyDown: util_1.callBoth(restProps.onKeyDown, handleKeyDown) }), Array(count)
        .fill(null)
        .map(function (_, index) {
        var itemValue = index * 2 + 2;
        var half = itemValue === current + 1 && current % 2 > 0;
        var full = itemValue <= current;
        var _a = tslib_1.__read(inject_value_1.injectValue(character)({
            index: index,
            half: half,
            full: full,
        }), 2), inactive = _a[0], active = _a[1];
        return (react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-rate__item"), key: index },
            allowHalf && (react_1.default.createElement("div", { className: classPrefix + "-rate__item-up", onClick: function (event) { return handleClick(event, itemValue - 1); }, onMouseEnter: function () { return handleMouseEnter(itemValue - 1); } }, !(full || half) ? inactive : active)),
            react_1.default.createElement("div", { className: classPrefix + "-rate__item-down", onClick: function (event) { return handleClick(event, itemValue); }, onMouseEnter: function () { return handleMouseEnter(itemValue); } }, !full ? inactive : active)));
    })));
});
//# sourceMappingURL=Rate.js.map